import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VisualizarErrosImportacaoService {

  constructor(private readonly http: HttpClient) { }

  getErrosDados(idImportacao: any) {
    const url: string = `/apiconnect/importations/${idImportacao}/errors`;

    return this.http.get(url);
  }

  getErrosLayout(idImportacao: any) {
    const url: string = `/apiconnect/file-database/imports-data/${idImportacao}/layout-errors`;

    return this.http.get(url);
  }

  public baixarRelatorioLayout(idImportacao) {
    return this.http.get(`/apiconnect/file-database/imports-data/${idImportacao}/csv-report`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
